import { useState } from 'react';
import { StorageKeys } from '@selfserve/react-utils';

export const storage = {
  SESSION: 'sessionStorage',
  LOCAL: 'localStorage',
} as const;

export const storageKeys = StorageKeys;

export type StorageType = typeof storage[keyof typeof storage];

export const useStorage = <T = any>(
  storage: StorageType,
  keyName: string,
  defaultValue?: T
): [T, (value: T | ((value: T) => T)) => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    const storedDefaultValue = defaultValue || null;
    try {
      const value = window[storage].getItem(keyName);

      if (value) {
        return JSON.parse(value);
      } else {
        window[storage].setItem(keyName, JSON.stringify(storedDefaultValue));
        return storedDefaultValue;
      }
    } catch (err) {
      return storedDefaultValue;
    }
  });

  const setValue = (value: T | ((value: T) => T)) => {
    const newValue = value instanceof Function ? value(storedValue) : value;
    try {
      window[storage].setItem(keyName, JSON.stringify(newValue));
    } finally {
      setStoredValue(newValue);
    }
  };

  return [storedValue, setValue];
};
